import { CountryList } from 'enums/country';
import { useLocation } from 'react-router-dom';
import { useQueryGetEntity } from 'services/auth/queries';
import { useSelector } from 'react-redux';
import { MembershipLevels, User, UserCompanyType } from '../shared/typesTS';

interface IEntity {
  id: number;
  entityId: number;
  entityType: number;
  companyName: string;
  countryCode: string;
  directorAuthorization: string;
}

const hasCreditProfilePage = (pathname: string): boolean => {
  return pathname.includes('credit-profile');
};

const useDisplayDirectorConsent = (
  checkCreditProfilePage?: boolean,
): { showDirectorConsent: boolean; isLoading: boolean } => {
  //@ts-ignore <- for the immutable state
  const userImmutable = useSelector((state) => state.getIn(['me', 'user']));
  const user: User = !!userImmutable && userImmutable.toJS();
  const isPro =
    user?.membership?.level &&
    user?.membership?.level?.name !== MembershipLevels.free &&
    user?.membership?.level?.name !== MembershipLevels.freeZA;
  const entityId = user?.company?.company_id;
  const countryCode = user?.locale?.countryCode;
  const { pathname } = useLocation();
  const { data, isLoading }: { data: IEntity; isLoading: boolean } = useQueryGetEntity(entityId, {
    enabled: !!entityId && !!checkCreditProfilePage,
  });
  const isGB = countryCode === CountryList.GREAT_BRITAIN;

  const isLimitedOrLLPCompany = [
    UserCompanyType.limitedCompany,
    UserCompanyType.limitedLiabilityPartnership,
  ].includes(user?.company?.type);

  const shouldFilterByCreditProfilePage = checkCreditProfilePage
    ? hasCreditProfilePage(pathname)
    : true;

  const directorAuthorized = data?.directorAuthorization === 'AUTHORIZED';

  const showDirectorConsent =
    !!user &&
    !isLoading &&
    isLimitedOrLLPCompany &&
    isGB &&
    shouldFilterByCreditProfilePage &&
    !directorAuthorized &&
    isPro;

  return { showDirectorConsent, isLoading: isLoading || !entityId };
};

export default useDisplayDirectorConsent;
